import { render } from "./SubscriptionsList.vue?vue&type=template&id=2c5cc7fc"
import script from "./SubscriptionsList.vue?vue&type=script&lang=js"
export * from "./SubscriptionsList.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "2c5cc7fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c5cc7fc', script)) {
    api.reload('2c5cc7fc', script)
  }
  
  module.hot.accept("./SubscriptionsList.vue?vue&type=template&id=2c5cc7fc", () => {
    api.rerender('2c5cc7fc', render)
  })

}

script.__file = "src/views/settings/modules/payments/SubscriptionsList.vue"

export default script